import type { Promotion, SinglePromotion } from '../Promotions.types'

export const isPromotionSingle = (promotion: Promotion): promotion is SinglePromotion =>
  promotion.type === 'SINGLE'
